var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"ib-button-tab",class:_vm.classes,style:({ height: _vm.height }),on:{"click":_vm.onClick}},[(!_vm.$slots['icon'] && _vm.icon)?[_c('i',{staticClass:"ib-button-icon mr-2",class:[_vm.icon]})]:_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }